<template>
    <div>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
        <v-container fluid>
            <div class="d-flex mb-4">
                <h2>{{ $t("SDG Goal Icon") }}</h2>
                <v-spacer></v-spacer>
            </div>
            <v-card elevation="0" class="px-5">
                <v-card-text>
                    <ReportList class="mt-4" :toggleSelection="false" :toggleFilterState="false" />
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import ReportList from './sdg-goal.vue';

export default {
    components: {
        ReportList,
    },
    data() {
        return {
            esgReports: [],
            breadcrumbs: [
                {
                    text: this.$t("esgPlatform.esgPlatform"),
                    disabled: false,
                    to: { name: "esg-dashboard" },
                    exact: true,
                },
                {
                    text: this.$t("SDG Goal"),
                    disabled: true,
                    href: "breadcrumbs_link_1",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
::v-deep .v-data-table-header span {
    text-transform: uppercase !important;
    color: black;
}
</style>
